import React from 'react'

export interface SiteHeaderProps {
  title?: string;
}

export function SiteHeader(header_props: SiteHeaderProps){
  return <h1 className="h1 text-center">{header_props?.title}</h1>
}
